import { useState, useCallback, createContext, useContext } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, title: "", description: "", onConfirm: null });

  const confirm = useCallback((title, description) => {
    return new Promise((resolve) => {
      setState({ open: true, title, description, onConfirm: () => { setState(s => ({ ...s, open: false })); resolve(true); } });
    });
  }, []);

  const cancel = () => { setState(s => ({ ...s, open: false })); };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={v => { if (!v) cancel(); }}>
        <AlertDialogContent className="bg-white border-[#E0E0DE] shadow-sm max-w-[400px]">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-[15px] font-semibold text-[#37352F]">{state.title}</AlertDialogTitle>
            <AlertDialogDescription className="text-[13px] text-[#6B6B6B]">{state.description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="text-[13px] h-8 border-[#E0E0DE] text-[#6B6B6B]">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={state.onConfirm} className="text-[13px] h-8 bg-[#2383E2] hover:bg-[#1B6EC2] text-white">Confirm</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
